<template>
  <div class="h-container max-w-[1650px] overflow-hidden border-b border-border-light pb-6 pt-8">
    <BackToProductButton />
    <Breadcrumbs v-if="props.adopterBreadcrumb?.length" class="justify-center" :elements="props.adopterBreadcrumb" />
    <Breadcrumbs v-else-if="props.breadcrumbs?.length" class="justify-center" :elements="props.breadcrumbs" />
    <h1 class="mt-2 text-center text-h2">{{ props.title }}</h1>
    <CategoryHeroSubcategories v-if="props.subcategories" :subcategories="props.subcategories" />
    <div
      v-if="hasHeader"
      class="mb-3 mt-11 lg:mt-10"
      :class="{
        'sm:h-gap sm:grid sm:grid-cols-2 sm:items-center': props.description && props.headerImage,
        'mx-auto sm:w-2/3': !props.headerImage,
      }"
    >
      <OnImg
        v-if="props.headerImage"
        class="size-full rounded-lg object-cover"
        :class="props.description ? 'aspect-[2/1]' : 'aspect-[3/1]'"
        :src="props.headerImage.src"
        :alt="props.headerImage.alt"
        sizes="440px xs:700px sm:1000px md:1280px"
        width="1280"
        height="640"
      />
      <div :class="{ 'pt-8 sm:px-5 sm:pt-4': props.headerImage }">
        <h2 v-if="props.titleLong" class="text-center text-h3" :class="{ 'mb-4': props.description }">{{ props.titleLong }}</h2>
        <div v-if="props.description" :class="{ 'text-center': !props.headerImage }" class="text" v-html="props.description" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import OnImg from '~/components/on-img/OnImg.vue'
import Breadcrumbs from '~/components/breadcrumbs/Breadcrumbs.vue'
import CategoryHeroSubcategories from '~/components/category-hero-subcategories/CategoryHeroSubcategories.vue'
import BackToProductButton from '~/components/category-hero/BackToProductButton.vue'

interface HeaderImage {
  src: string
  alt?: string
}

interface Breadcrumb {
  name: string
  url: string
}

interface HallSubCategory {
  title: string
  url: string
  tileImage: string | null
  rank: number
}

interface CategoryHeroProps {
  adopterBreadcrumb?: Breadcrumb[] | null
  breadcrumbs?: Breadcrumb[] | null
  subcategories?: HallSubCategory[] | null
  title?: string | null
  titleLong?: string | null
  headerImage?: HeaderImage | null
  description?: string | null
}

const props = withDefaults(defineProps<CategoryHeroProps>(), {
  adopterBreadcrumb: () => [],
  breadcrumbs: () => [],
  subcategories: () => [],
  title: null,
  titleLong: null,
  headerImage: null,
  description: null,
})

const hasHeader = computed(() => {
  return props.headerImage || props.titleLong || props.description
})
</script>
